var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { ethers } from "ethers";
import { CHAINID, NODE_URI, isDevelopment } from "../utils/env";
import { isAvaxNetwork } from "../constants/constants";
var defaultProvider = new ethers.providers.StaticJsonRpcProvider(NODE_URI[isDevelopment() ? CHAINID.BSC_TEST : CHAINID.BSC_MAINNET]);
var avaxProvider = new ethers.providers.StaticJsonRpcProvider(NODE_URI[isDevelopment() ? CHAINID.AVAX_FUJI : CHAINID.AVAX_MAINNET]);
export var Web3Context = React.createContext({
    provider: defaultProvider,
});
export var AvaxWeb3Context = React.createContext({
    provider: avaxProvider,
});
export var useWeb3Context = function (chainId) {
    if (chainId === void 0) { chainId = CHAINID.ETH_MAINNET; }
    var context = Web3Context;
    if (isAvaxNetwork(chainId))
        context = AvaxWeb3Context;
    return useContext(context);
};
export var useETHWeb3Context = function () {
    return useContext(Web3Context);
};
export var Web3ContextProvider = function (_a) {
    var children = _a.children;
    return (_jsx(Web3Context.Provider, __assign({ value: { provider: defaultProvider } }, { children: _jsx(AvaxWeb3Context.Provider, __assign({ value: { provider: avaxProvider } }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=web3Context.js.map